import I18n from 'I18n';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIcon from 'UIComponents/icon/UIIcon';
import { PAGE_IDS } from '../../constants/pageConfigs';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TableBoardIconSwitcher({
  pageId
}) {
  const queryParamsString = useQueryParamString();
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    children: [/*#__PURE__*/_jsx(UIRouterButton, {
      "data-test-id": "table-board-icon-switcher-button--table",
      size: "xs",
      title: I18n.text('crm-tasks-ui.pageTitles.table'),
      to: `/${queryParamsString}`,
      use: "tertiary-light"
      // TODO post-TS migration, discuss active prop usage with UIComponents team
      // @ts-expect-error active is hidden prop
      ,
      active: pageId === PAGE_IDS.TASKS_HOME,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "listView"
      })
    }), /*#__PURE__*/_jsx(UIRouterButton, {
      "data-test-id": "table-board-icon-switcher-button--board",
      size: "xs",
      title: I18n.text('crm-tasks-ui.pageTitles.table'),
      to: `/board${queryParamsString}`,
      use: "tertiary-light"
      // @ts-expect-error active is hidden prop
      ,
      active: pageId === PAGE_IDS.LEGACY_BOARD,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "grid"
      })
    })]
  });
}